import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppLayoutComponent } from './shared/layout/app-layout/app-layout.component';
import { ParametrageLayoutComponent } from './shared/layout/parametrage-layout/parametrage-layout.component';
import { AccountLayoutComponent } from './shared/layout/account-layout/account-layout.component';

import { NgxPermissionsGuard } from 'ngx-permissions';

const routes: Routes = [

  {
    path: '',
    component: AppLayoutComponent, 
    children: 
    [
      
      { 
        path: '',
        loadChildren: () => import('./new-dashboard/new-dashboard.module').then(x => x.NewDashboardModule)
      },
      {
        path: 'new-dashboard',
        loadChildren: () => import('./new-dashboard/new-dashboard.module').then((m) => m.NewDashboardModule)
      },

      { 
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.module').then(x => x.DashboardModule)
      },

      { 
        path: 'mon-portefeuille',
        loadChildren: () => import('./mon-portefeuille/mon-portefeuille.module').then(x => x.MonPortefeuilleModule)
      },

      { 
        path: 'support-client',
        loadChildren: () => import('./support-client/support-client.module').then(x => x.SupportClientModule)
      },

      { 
        path: 'contentieux',
        loadChildren: () => import('./contentieux/contentieux.module').then(x => x.ContentieuxModule)
      },

      { 
        path: 'suivi-portefeuille',
        loadChildren: () => import('./suivi-portefeuille/suivi-portefeuille.module').then(x => x.SuiviPortefeuilleModule)
      },

      { path: 'product-program',
        loadChildren: () => import('./product-program/product-program.module').then(x => x.ProductProgramModule)
      },
      
      { 
        path: 'fonds-propres',
        loadChildren: () => import('./fonds-propres/fonds-propres.module').then(x => x.FondsPropresModule),
      },

      { path: 'cnce-corporate',
        loadChildren: () => import('./corporate/corporate.module').then(x => x.CorporateModule)
      },
      
      { path: 'cnce-professionnel',
        loadChildren: () => import('./professionnel/professionnel.module').then(x => x.ProfessionnelModule)
      },
      
      { path: 'retail',
        loadChildren: () => import('./particulier/particulier.module').then(x => x.ParticulierModule)
      },
      
      { path: 'comite-credit',
        loadChildren: () => import('./comite-credit/comite-credit.module').then(x => x.ComiteCreditModule)
      },
      
      {
        path: 'reporting',
        loadChildren: () => import('./reporting/reporting.module').then((m) => m.ReportingModule)
      },

      {
        path: 'crm',
        loadChildren: () => import('./crm/crm.module').then((m) => m.CrmModule)
      },


      {
        path: 'historique-client',
        loadChildren: () => import('./historique-client/historique-client.module').then((m) => m.HistoriqueClientModule)
      },

      
    ]
  },

  {
    path: '',
    component: ParametrageLayoutComponent, 
    children: 
    [
      { 
        path: '',
        loadChildren: () => import('./parametrage/parametrage.module').then(x => x.ParametrageModule)
      },
      { 
        path: 'parametrage',
        loadChildren: () => import('./parametrage/parametrage.module').then(x => x.ParametrageModule)
      }
    ]
  },


  {
    path: '',
    component: AccountLayoutComponent, 
    children: 
    [
      { 
        path: '',
        loadChildren: () => import('./account/account.module').then(x => x.AccountModule)
      },
      { 
        path: 'account',
        loadChildren: () => import('./account/account.module').then(x => x.AccountModule)
      }
    ]
  },

  

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes,{ enableTracing: false })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
